import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';

// ModalStyles
import styles from "./../StaffManagment.module.css";
import ModalStyles from "./../../DashboardReuseAbleComponents/Modal.module.css";

const ModalCommissionStaffFinancial = (props) => {

    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                show={props.show}
                onHide={props.onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            درصد کمیسیون
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body dir="rtl" className={`my-3`}>
                    <div className={`w-50 mx-auto px-3 text-center ${styles.total_modal_body_files_box}`}>
                        <h3 className={`${styles.title_modal_body_files_box}`}> لطفا درصد کمیسیون را انتخاب کنید </h3>
                        <p className={`mt-3 mb-4 ${styles.text_modal_body_files_box}`}>
                            درصد کمیسیون بر روی تمام فایل ها اعمال خواهد شد و به
                            صورت تکی برای هر فایل قابل تغییر میباشد
                        </p>
                        <div className={`pt-3 ${styles.total_percentage_modal_body_files_box}`}>
                            <Form.Group className="position-relative">
                                <Form.Label className={`w-100 mb-2 text-right ${styles.title_percentage_modal_body_files_box}`}> درصد کمیسیون </Form.Label>
                                <Form.Control
                                    className={`${styles.form_percentage_modal_body_files_box} shadow-none`}
                                    type="text"
                                    id="commissionPercentage"
                                    name="commissionPercentage"
                                    value={e2p(props.formModalCommissionPercentage.commissionPercentage?.toString())}
                                    onChange={props.changeFormModalCommissionHandler}
                                />
                                <Form.Text className={`position-absolute top-50 start-0 px-3`}> درصد </Form.Text>
                            </Form.Group>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center align-items-center mb-3'>
                        <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`}>
                            ثبت
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalCommissionStaffFinancial;